import React, { FC } from 'react';
import {
  SystemButtonProps,
  SystemButtonDefault,
  SystemButtonContent,
} from '../SystemButton';
import styles from './primary_button.module.scss';

export const PrimaryButton: FC<SystemButtonProps> = ({
  children,
  onClick,
  disabled,
  dataName,
  iconLeft,
  iconRight,
  type,
  id,
}) => {
  const commonProps = {
    className: styles.primary,
    name: dataName,
    disabled,
    id,
  };
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
          {children}
        </SystemButtonContent>
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} {...commonProps}>
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </button>
  );
};

PrimaryButton.defaultProps = SystemButtonDefault;
